var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 240,
    height: 220,
    viewBox: "0 0 240 220",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    filter: "url(#filter0_d_21_6113)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 120,
    cy: 88,
    r: 48,
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Envelope"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M102.5 73C102.102 73 101.721 73.158 101.439 73.4393C101.158 73.7206 101 74.1022 101 74.5V100C101 100.796 101.316 101.559 101.879 102.121C102.441 102.684 103.204 103 104 103H137C137.796 103 138.559 102.684 139.121 102.121C139.684 101.559 140 100.796 140 100V74.5C140 74.1022 139.842 73.7206 139.561 73.4393C139.279 73.158 138.898 73 138.5 73H102.5ZM106.357 76H134.643L120.5 88.9656L106.357 76ZM104 98.0894V77.9106L115.008 88L104 98.0894ZM119.478 92.1062C119.755 92.3603 120.117 92.5012 120.493 92.5012C120.868 92.5012 121.23 92.3603 121.507 92.1062L123.757 90.0344L134.632 100H106.357L117.228 90.0344L119.478 92.1062ZM137 77.9088V98.0913L125.992 88L137 77.9088Z",
    fill: "#E7454C"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_21_6113",
    x: 0,
    y: -20,
    width: 240,
    height: 240,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 12
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 36
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_21_6113"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_21_6113",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.943b53c866d7e38e0a35f9cc20b55af5.svg";
export { ForwardRef as ReactComponent };